/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_IS_STREAMING_RESTRICTED } from './streamingrestriction.types';
import { setIsStreamingRestrictedAction } from './streamingrestriction.actions';

const initialState: {
    isStreamingRestricted: boolean;
} = {
    isStreamingRestricted: false,
};

const streamingRestrictionsReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_IS_STREAMING_RESTRICTED:
            return {
                ...state,
                isStreamingRestricted: payload.isStreamingRestricted,
            };
        default:
            return state;
    }
};

export const setIsStreamingRestricted =
    (isStreamingRestricted: boolean) => (dispatch: Function) => {
        dispatch(setIsStreamingRestrictedAction(isStreamingRestricted));
    };

export default streamingRestrictionsReducer;
